import { Component, OnInit } from '@angular/core';
import { OrgService } from 'src/app/organization/org.service';
import { UserService } from 'src/app/user/user.service';
declare let dataLayer;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  footerlogoList: any[] = [];
  imageObject: any[] = [];

  constructor(private orgService: OrgService, private userService: UserService) { }

  ngOnInit() {
    this.getSponsorLogoList();
  }

  imageClickHandler(event, x) {
    const url = this.footerlogoList.filter(obj => (obj.sponsorLogoUrl == x.image));
    const orgName = this.userService.CurrentUser ? this.userService.CurrentUser.orgName : '';
    // dataLayer.push({
    //   event: 'sponsor_logo_click'
    // });
    window.open(url[0].websiteUrl, '_blank');
  }

  getSponsorLogoList() {
    this.orgService.getSponsorLogoList().subscribe((info: any) => {
      this.footerlogoList = info;
      info.forEach(element => {
        this.imageObject.push({ image: element.sponsorLogoUrl, thumbImage: element.sponsorLogoUrl });
      });
    });
  }
}
